module.exports = __webpack_public_path__ + "ae571af0820eaa8d19664b9ca7e3d4a5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/lk.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/lk.svg
// module chunks = 0